export default "__VITE_ASSET__CTTlmTZV__"